
import { WebRTC } from './WebRTC'
import { notifyAgentDescription, notifyAgentIceCandidate, notifyAgentDetails } from '../actions/signaling'
import { notifySendKeyboardEvent, notifySendMouseEvent, notifySendCommand } from '../actions/toolbar'
import { clipboardRemoteSend } from '../actions/clipboard'
import {
  closePeerConnection,
  connectionClosedByPeer,
  changeMonitor,
  audioChatTrackChange,
  sendCommand,
  accessRejected,
} from '../actions/webrtcConnection'
import { setDisconnectMessage, gracefulExit } from '../actions/disconnect'
import { updateFeatures } from '../actions/app'
import { buildSilenceAudio, audioChatStatsRequest } from '../actions/media'
import { CommandsMessageCreator } from './create/CommandsMessageCreator'
import { logger } from './utils/logger'

export const createWebRTCMiddleware =
(
  deps = {
    commandsMessageCreator: new CommandsMessageCreator(),
    createWebRTC: WebRTC.create,
  }
) => {
  return () => {
    return (store) => {
      const webRTC = deps.createWebRTC(store)

      return (next) => (action) => {
        const actions = {
          [notifyAgentDetails]: (payload) => {
            store.dispatch(updateFeatures(payload))
            if (store.getState().features.audioChat) {
              store.dispatch(buildSilenceAudio())
            }
            webRTC.createOffer(payload)
          },
          [notifyAgentDescription]: webRTC.synchronizeDescriptions,
          [notifyAgentIceCandidate]: webRTC.addIceCandidate,
          [notifySendKeyboardEvent]: webRTC.sendKeyboardEvent,
          [notifySendMouseEvent]: webRTC.sendMouseEvent,
          [notifySendCommand]: webRTC.sendCommand,
          [accessRejected]: () => {
            webRTC.willClose()
          },
          [closePeerConnection]: () => {
            // come from logic/app on restartRtc or from logic/disconnect.gracefulExit
            const connectionClosedMessage = deps.commandsMessageCreator.createConnectionClosed()
            webRTC.sendCommand(connectionClosedMessage)
            webRTC.willClose()
            webRTC.onClosePeerConnection()
          },
          [connectionClosedByPeer]: () => {
            webRTC.willClose()
            store.dispatch(gracefulExit())
            store.dispatch(setDisconnectMessage('disconnect-by-peer'))
          },
          [changeMonitor]: (payload) => {
            const changeMonitorMessage = deps.commandsMessageCreator.createChangeMonitor(payload)
            webRTC.sendCommand(changeMonitorMessage)
          },
          [sendCommand]: (payload) => {
            webRTC.sendCommand(payload)
          },
          [audioChatTrackChange]: (payload) => {
            webRTC.setAudioChatTrack(payload)
          },
          [audioChatStatsRequest]: () => {
            webRTC.audioChatStatsRequest()
          },
          /* end audio chat actions */
          [clipboardRemoteSend]: (payload) => {
            logger('clipboard remote send', payload)
            const clipboardTextMessage = deps.commandsMessageCreator.createSendClipboardRequest(payload)
            webRTC.sendCommand(clipboardTextMessage)
          }
        }

        if (actions.hasOwnProperty(action.type)) {
          actions[action.type](action.payload)
        }

        return next(action)
      }
    }
  }
}

